import { LegendToggle } from "@mui/icons-material";
import PrintIcon from "@mui/icons-material/Print";
import {
  Badge,
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { FullPageSpinner } from "../lib";
import ResponsiveDialog from "../shared/components/ResponsiveDialog.js";
import openFile from "../shared/functions/download";
import { Kalender } from "./Kalender.js";
function Fehlzeitenkalender(props) {
  const { t } = useTranslation();
  const {
    client,
    accessToken,
    onlineid,
    jahresAnsicht = false,
    onJahresAnsichtChange,
    nurkonten,
    year = 2026,
    setYear,
    month = 0,
    setMonth,
    uebevents,
    ueblegende,
    uebsondertage,
    noYearRefresh = false,
  } = props;
  const [events, setEvents] = useState(uebevents ? uebevents : []);
  const { showErrorMessage } = useMessage();
  const [legende, setLegende] = useState(ueblegende ? ueblegende : []);
  const [sondertage, setSondertage] = useState(uebsondertage ? uebsondertage : []);
  const [salden, setSalden] = useState([]);
  const [jahrurl, setJahrurl] = useState("");
  const [jahrkrank, setJahrkrank] = useState("");
  const [urlindex, setUrlindex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [legendDialogOpen, setLegendDialogOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!onlineid) return;
    if (!noYearRefresh) {
      setShowModal(true);
      const payload = {
        mandant: client,
        program:
          location.pathname === "/PMABWU"
            ? "PMABWU"
            : location.pathname === "/PMABW2"
              ? "PMABW2"
              : location.pathname === "/PMABW3"
                ? "PMABW3"
                : location.pathname.substr(0, 7) === "/PMURB3"
                  ? "PMURB3"
                  : "PMURA1",
        statement: "KALENDER",
        onlineid: onlineid,
        jahr: year,
      };

      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postLaden, errorCb);
    }
    // eslint-disable-next-line
  }, [year, onlineid]);

  useEffect(() => {
    setUrlindex(0);
  }, [onlineid]);

  const postLaden = (response) => {
    setShowModal(false);
    if (response.status === 200) {
      setEvents(response.data.events || []);
      setLegende(response.data.legende || []);
      setSondertage(response.data.sondertage || []);
      setSalden(response.data.salden || []);
      if (response.data.jahrstats) {
        setJahrurl(response.data.jahrstats.url);
        setJahrkrank(response.data.jahrstats.krank);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const errorCb = () => {
    setShowModal(false);
    showErrorMessage(t("Kalenderdaten konnten nicht geladen werden."));
  };

  const tableStyle = (red, green, blue, border) => {
    if (red) {
      if (border) {
        if (border === "J") {
          return {
            backgroundColor: `rgba(${red},${green},${blue},0)`,
            color: `rgba(${red},${green},${blue},1)`,
            border: `2px solid rgba(${red},${green},${blue},0.7)`,
            borderRadius: "5px",
            padding: "2px 4px",
          };
        } else {
          return {
            backgroundColor: `rgba(${red},${green},${blue},0.7)`,
            color: `rgba(${"000"},${"000"},${"000"},1)`,
            border: `2px solid rgba(${red},${green},${blue},0.7)`,
            borderRadius: "5px",
            padding: "2px 4px",
          };
        }
      } else {
        return {
          backgroundColor: `rgba(${red},${green},${blue},0.7)`,
          color: `rgba(${"000"},${"000"},${"000"},1)`,
          border: `2px solid rgba(${red},${green},${blue},0.7)`,
          borderRadius: "5px",
          padding: "2px 4px",
        };
      }
    } else {
      return {};
    }
  };
  function Jahreswechsel(newYear, newMonth) {
    setYear(newYear);
    setMonth(newMonth);
  }

  function Drucken() {
    setShowModal(true);
    const payload = {
      mandant: client,
      program:
        location.pathname === "/PMABWU"
          ? "PMABWU"
          : location.pathname === "/PMABW2"
            ? "PMABW2"
            : location.pathname === "/PMABW3"
              ? "PMABW3"
              : location.pathname.substr(0, 7) === "/PMURB3"
                ? "PMURB3"
                : "PMURA1",
      statement: "KALENDER_DRUCKEN",
      jahr: year,
      user: onlineid,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
        var fileName = "Kalender_" + year + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setShowModal(false);
      })
      .catch(function (error) {
        console.log(error);
        setShowModal(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }

  const handleLegendOpen = () => {
    setLegendDialogOpen(true);
  };

  return (
    <div>
      {nurkonten && salden && salden.length > 0 && (
        <Fragment>
          <Grid item xs={12} md={6} lg={4}>
            <Button id="vor" onClick={() => Jahreswechsel(year - 1, 11)}>
              {t("Vorjahr")}
            </Button>
            <Typography style={{ display: "inline-block" }}>{year.toString()}</Typography>
            <Button id="vor" onClick={() => Jahreswechsel(year + 1, 0)}>
              {t("Nächstes Jahr")}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell  colSpan={2}>
                      {t("Jahreswerte")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell >{t("Urlaubstage")}</TableCell>
                    <TableCell >{jahrurl}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >{t("Kranktage")}</TableCell>
                    <TableCell >{jahrkrank}</TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell  colSpan={2}>
                      {t("Urlaubsstatistik")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {salden && salden.length > 1 && (
                    <TableRow>
                      <TableCell  colspan={2}>
                        <TextField
                          size="small"
                          id="saldo"
                          label={t("Urlaubskonto")}
                          select
                          fullWidth
                          value={urlindex}
                          onChange={(e) => {
                            setUrlindex(e.target.value);
                          }}
                          variant="outlined"
                        >
                          {salden.map((item, index) => (
                            <MenuItem key={index} value={index}>
                              {item.bez}
                            </MenuItem>
                          ))}
                        </TextField>
                      </TableCell>
                    </TableRow>
                  )}
                  {typeof salden[urlindex] === "object" && (
                    <Fragment>
                      <TableRow>
                        <TableCell >{t("Rest Vorjahr")}</TableCell>
                        <TableCell >{salden[urlindex].restvorjahr}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell >{t("Jahresurlaub")}</TableCell>
                        <TableCell >{salden[urlindex].jahresurlaub}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell >{t("Genommen")}</TableCell>
                        <TableCell >{salden[urlindex].genommen}</TableCell>
                      </TableRow>
                      {salden[urlindex].korrektur && (
                        <TableRow>
                          <TableCell >{t("Korrektur")}</TableCell>
                          <TableCell >{salden[urlindex].korrektur}</TableCell>
                        </TableRow>
                      )}
                      {salden[urlindex].ausbezahlt && (
                        <TableRow>
                          <TableCell >{t("Ausbezahlt")}</TableCell>
                          <TableCell >{salden[urlindex].ausbezahlt}</TableCell>
                        </TableRow>
                      )}
                      {salden[urlindex].verfallen && (
                        <TableRow>
                          <TableCell >{t("Verfallen")}</TableCell>
                          <TableCell >{salden[urlindex].verfallen}</TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell >{t("Endstand")}</TableCell>
                        <TableCell >{salden[urlindex].endstand}</TableCell>
                      </TableRow>
                    </Fragment>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Fragment>
      )}
      {!nurkonten && (
        <Fragment>
          <Kalender
            year={year}
            events={events}
            month={month}
            onMonthChange={setMonth}
            jahresAnsicht={jahresAnsicht}
            onJahresAnsichtChange={onJahresAnsichtChange}
            onYearChange={Jahreswechsel}
          ></Kalender>
          <Grid container justifyContent="center">
            <Grid item>
          <Box p={1}>
            <Tooltip title={t("Jahreskalender drucken")}>
              <IconButton size="small" variant="contained" color="primary" onClick={() => Drucken()}>
                <PrintIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </Box>
          </Grid>
          <Grid item>
          <Box p={1}>
            <Tooltip title={t("Legende und Informationen")}>
              <IconButton size="small" color="primary" onClick={handleLegendOpen}>
                <LegendToggle fontSize="large"/>
              </IconButton>
            </Tooltip>
          </Box>
          </Grid>
          </Grid>
          <ResponsiveDialog open={legendDialogOpen} setOpen={setLegendDialogOpen} title={t("Legende und Informationen")}>
            {legende && legende.length > 0 && (
              <Box p={1}>
              <Typography variant="h6" gutterBottom>
                {t("Legende")}
              </Typography>
                <Table size="small">
                  <TableBody>
                    {legende.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Badge style={tableStyle(item.red, item.green, item.blue, item.antrag)}>{item.fz}</Badge>

                          {" " + item.bez}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
            {sondertage && sondertage.length > 0 && (
              <Box p={1}>
              <Typography variant="h6" gutterBottom>
                {t("Feiertage/Betriebliche Sondertage")}
              </Typography>
                <Table size="small">
                  <TableBody>
                    {sondertage.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.bez}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
            {salden && salden.length > 0 && (
              <Box p={2}>
              <Typography variant="h6" gutterBottom>
                {t("Jahreswerte")}
              </Typography>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>{t("Urlaubstage")}</TableCell>
                      <TableCell >{jahrurl}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell >{t("Kranktage")}</TableCell>
                      <TableCell >{jahrkrank}</TableCell>
                    </TableRow>
                  </TableBody>
                  <TableHead>
                    <TableRow>
                      <TableCell  colSpan={2}>
                        {t("Urlaubsstatistik")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {salden && salden.length > 1 && (
                      <TableRow>
                        <TableCell  colspan={2}>
                          <TextField
                            size="small"
                            id="saldo"
                            label={t("Urlaubskonto")}
                            select
                            fullWidth
                            value={urlindex}
                            onChange={(e) => {
                              setUrlindex(e.target.value);
                            }}
                            variant="outlined"
                          >
                            {salden.map((item, index) => (
                              <MenuItem key={index} value={index}>
                                {item.bez}
                              </MenuItem>
                            ))}
                          </TextField>
                        </TableCell>
                      </TableRow>
                    )}
                    {typeof salden[urlindex] === "object" && (
                      <Fragment>
                        <TableRow>
                          <TableCell >{t("Rest Vorjahr")}</TableCell>
                          <TableCell >{salden[urlindex].restvorjahr}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell >{t("Jahresurlaub")}</TableCell>
                          <TableCell >{salden[urlindex].jahresurlaub}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell >{t("Genommen")}</TableCell>
                          <TableCell >{salden[urlindex].genommen}</TableCell>
                        </TableRow>
                        {salden[urlindex].korrektur && (
                          <TableRow>
                            <TableCell >{t("Korrektur")}</TableCell>
                            <TableCell >{salden[urlindex].korrektur}</TableCell>
                          </TableRow>
                        )}
                        {salden[urlindex].ausbezahlt && (
                          <TableRow>
                            <TableCell >{t("Ausbezahlt")}</TableCell>
                            <TableCell >{salden[urlindex].ausbezahlt}</TableCell>
                          </TableRow>
                        )}
                        {salden[urlindex].verfallen && (
                          <TableRow>
                            <TableCell >{t("Verfallen")}</TableCell>
                            <TableCell >{salden[urlindex].verfallen}</TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                          <TableCell >{t("Endstand")}</TableCell>
                          <TableCell >{salden[urlindex].endstand}</TableCell>
                        </TableRow>
                      </Fragment>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}
          </ResponsiveDialog>
        </Fragment>
      )}
      {showModal && <FullPageSpinner />}
    </div>
  );
}
export { Fehlzeitenkalender };

